import { useEffect, useRef, useState } from "react";
import { POLLING_INTERVAL } from "../utils/fileManagerConstants";
import { hasProcessingFiles } from "../utils/fileManagerHelpers";

/**
 * Custom hook for polling file status updates
 * @param {Object} params - Hook parameters
 * @param {Array} params.files - Array of file objects
 * @param {boolean} params.isOpen - Whether modal is open
 * @param {Function} params.refetch - Refetch function from useQuery
 * @returns {Object} Hook return values
 */
export const useFilePolling = ({ files, isOpen, refetch }) => {
  const [isPolling, setIsPolling] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    // Only poll if modal is open and there are processing files
    const shouldPoll = isOpen && hasProcessingFiles(files);

    if (shouldPoll) {
      setIsPolling(true);

      // Start polling
      intervalRef.current = setInterval(() => {
        refetch();
      }, POLLING_INTERVAL);
    } else {
      setIsPolling(false);
    }

    // Cleanup on unmount or when dependencies change
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [files, isOpen, refetch]);

  return {
    isPolling,
  };
};
